import { useResetRecoilState } from "recoil";
import {
  selectedWorkCompanyState,
  selectedWorkDocumentClassState,
  selectedWorkPjTagState,
  selectedWorkTopicTagsState,
  workFormStepState,
} from "store/document/workDocument";

const useResetWorkDocStates = () => {
  const resetWorkFormStep = useResetRecoilState(workFormStepState);
  const resetSelectedDocumentClass = useResetRecoilState(
    selectedWorkDocumentClassState,
  );
  const resetSelectedDocumentCompanyTag = useResetRecoilState(
    selectedWorkCompanyState,
  );
  const resetSelectedPjTag = useResetRecoilState(selectedWorkPjTagState);
  const resetSelectedTopicTags = useResetRecoilState(
    selectedWorkTopicTagsState,
  );

  const resetWorkDocStates = () => {
    resetSelectedDocumentCompanyTag();
    resetSelectedPjTag();
    resetSelectedDocumentClass();
    resetSelectedTopicTags();
    resetWorkFormStep();
  };

  return {
    resetWorkDocStates,
  };
};

export default useResetWorkDocStates;
